export default __webpack_public_path__ + "static/media/project2.1baff6a9.png";